import socialMedia from './_socialMedia';
import { getBaseUrl } from './utils';
const ABSOLUTE_BASEURL = 'https://www.nib.com.au';
const getFoundationConfig = config => {
  const baseUrl = getBaseUrl(config, ABSOLUTE_BASEURL);
  return {
    id: 'footer-foundation',
    columns: [{
      id: 'ga-footer-foundation-about-us',
      title: 'About Us',
      children: [{
        id: 'ga-footer-foundation-about-us-about-us',
        title: 'About Us',
        url: `${baseUrl}/foundation/about-us`
      }, {
        id: 'ga-footer-foundation-about-us-leadership-team',
        title: 'Leadership Team',
        url: `${baseUrl}/foundation/about-us/leadership-team`
      }, {
        id: 'ga-footer-foundation-about-us-community-reports',
        title: 'Community Report',
        url: `${baseUrl}/foundation/about-us/community-report`
      }, {
        id: 'ga-footer-foundation-about-us-privacy-policy',
        title: 'Privacy Policy',
        url: `${baseUrl}/docs/foundation-privacy-policy`
      }, {
        id: 'ga-footer-foundation-about-us-news',
        title: 'Stories',
        url: `${baseUrl}/foundation/stories`
      }]
    }, {
      id: 'ga-footer-foundation-partners',
      title: 'Partners',
      children: [{
        id: 'ga-footer-foundation-partners-our-partners',
        title: 'Our Partners',
        url: `${baseUrl}/foundation/our-partners`
      }, {
        id: 'ga-footer-foundation-partners-partnerships',
        title: 'Partnerships',
        url: `${baseUrl}/foundation/our-partners/partnerships`
      }, {
        id: 'ga-footer-foundation-partners-health-smart-partners',
        title: 'Health Support',
        url: `${baseUrl}/foundation/our-partners/health-support`
      }]
    }, {
      id: 'ga-footer-foundation-funding',
      title: 'Funding',
      children: [{
        id: 'ga-footer-foundation-funding-funding',
        title: 'Funding',
        url: `${baseUrl}/foundation/funding`
      }, {
        id: 'ga-footer-foundation-prevention-partnersips-program',
        title: 'Prevention Partnerships program',
        url: `${baseUrl}/foundation/funding/prevention-partnerships-program`
      }, {
        id: 'ga-footer-foundation-aboriginal-health-partnerships',
        title: 'Aboriginal Health Partnerships funding',
        url: `${baseUrl}/foundation/funding/aboriginal-health-partnerships-funding`
      }, {
        id: 'ga-footer-foundation-community-support',
        title: 'Community Support',
        url: `${baseUrl}/foundation/funding/community-support`
      }]
    }],
    contact: {
      heading: 'Get in touch',
      email: 'enquiries@nibfoundation.com.au',
      address: {
        mail: ['Locked Bag 2010,', 'Newcastle NSW 2300'],
        office: ['22 Honeysuckle Drive,', 'Newcastle NSW 2300']
      },
      socialLinks: socialMedia
    },
    smallFooterConfig: {
      id: 'small-footer-foundation',
      copyrightText: 'nib foundation is a not for profit charitable organisation established by nib health insurance.',
      links: []
    }
  };
};
export default getFoundationConfig;